import {EsigningEmailRecipients } from "../../../../../models/settings/document-settings-data";
import { DocumentationType, MeetingLocationType, MeetingOnlineType } from "@models/documents/document-enums";
import { SelectOption } from "@models/ui-models/select-options";

export const NotifyWhenAllPartiesSignedDocumentLabelRecord: Record<EsigningEmailRecipients, string> = {
  [EsigningEmailRecipients.SenderOnly]: 'Sender Only',
  [EsigningEmailRecipients.RecipientsOnly]: 'Recipients Only',
  [EsigningEmailRecipients.SenderAndRecipients]: 'Sender and Recipients',
  [EsigningEmailRecipients.DoNotSend]: 'Do not Send',
};

export const NotifyWhenAllPartiesSignedDocumentOptions: SelectOption[] = [
  {
    label: NotifyWhenAllPartiesSignedDocumentLabelRecord[EsigningEmailRecipients.SenderOnly],
    value: EsigningEmailRecipients.SenderOnly
  },
  {
    label: NotifyWhenAllPartiesSignedDocumentLabelRecord[EsigningEmailRecipients.RecipientsOnly],
    value: EsigningEmailRecipients.RecipientsOnly
  },
  {
    label: NotifyWhenAllPartiesSignedDocumentLabelRecord[EsigningEmailRecipients.SenderAndRecipients],
    value: EsigningEmailRecipients.SenderAndRecipients
  },
  {
    label: NotifyWhenAllPartiesSignedDocumentLabelRecord[EsigningEmailRecipients.DoNotSend],
    value: EsigningEmailRecipients.DoNotSend
  },
];

export const MeetingLocationTypeOptions: SelectOption[] = [
  {
    label: MeetingLocationType[MeetingLocationType.Registered],
    value: MeetingLocationType.Registered
  },
  {
    label: MeetingLocationType[MeetingLocationType.Principal],
    value: MeetingLocationType.Principal
  },
  {
    label: MeetingLocationType[MeetingLocationType.Phone],
    value: MeetingLocationType.Phone
  },
  {
    label: MeetingLocationType[MeetingLocationType.Other],
    value: MeetingLocationType.Other
  },
  {
    label: MeetingLocationType[MeetingLocationType.Online],
    value: MeetingLocationType.Online
  }
];

export const MeetingOnlineTypeOptions: SelectOption[] = [
  {
    label: MeetingOnlineType[MeetingOnlineType.GoogleMeet],
    value: MeetingOnlineType.GoogleMeet
  },
  {
    label: MeetingOnlineType[MeetingOnlineType.Zoom],
    value: MeetingOnlineType.Zoom
  },
  {
    label: MeetingOnlineType[MeetingOnlineType.MicrosoftTeams],
    value: MeetingOnlineType.MicrosoftTeams
  }
];



